import React, {useState, useEffect} from "react";
import Base64 from 'Base64';
import { Card, CardBody, CardHeader, CardImg, CardLink, CardText, CardTitle, Col, Input, ListGroup, ListGroupItem, Row, Modal, ModalBody, ModalFooter, ModalHeader, Button, Form, FormGroup, Label, Table} from 'reactstrap';
import ComboBox from './component/ComboBox.js';
import Page from 'components/Page';

import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import DataAdapter from "./adapter/DataAdapter";

import ReactQuill, { Quill, Mixin, Toolbar }  from "react-quill-with-table";
import QuillBetterTable from "quill-better-table";
import 'quill-better-table/dist/quill-better-table.css'
import 'react-quill/dist/quill.snow.css';

const notificationSystem = React.createRef();
const addNotification = (_MESSAGE_, _TYPE_) => {
		const notification = notificationSystem.current;
		notification.addNotification({message: _MESSAGE_, level: _TYPE_});
	};

var log	=	[];
var index   =1;

function FormConversation (props) {
	
	const [templateType, setTemplateType]	=	useState(-1);
	const [templateId, setTemplateId]		=	useState(-1);
	const [template_text, setTemplate_text]	=	useState(-1);
	const [email_step, setEmail_step]		=	useState(5);
	const [person, setPerson]				=	useState([]);
	const [email, setEmail]					=	useState([]);
	const [sms, setSMS]						=	useState([]);
	const [email_from, setEmail_from]		=	useState('info@renobuilding.ca');
	const [email_pass, setEmail_pass]		=	useState('Y@allah1');
	const [email_subject, setEmail_subject]	=	useState('');
	const [email_text, setEmail_text]		=	useState('');
	const [sms_body, setSms_body]			=	useState('');
	const [numberOfSeleteced, setNumberOfSeleteced]			=	useState(0);
	const [currentIndex, setCurrentIndex]					=	useState(0);

    const runQuery=(query, message)=>{
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/' , requestOptions)
			.then(response => {
				return Promise.all([response.json(),response])
			})
			.then(([responseData,response]) => {
				addNotification(message, 'success');
					
			})
			.catch(error => {
				console.error('Error:', error);
			})		
	}


	const onSendEmailHandler = (email_to, email_text) =>{
		
		
		
		let formData = new FormData();
		formData.append("from", 	email_from);
		formData.append("bcc", 		'log@8co.ca');
		formData.append("to", 		email_to);
		formData.append("subject", 	email_subject);
		formData.append("text",     email_text);
		formData.append("pass",     email_pass);
		
		let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
		fetch('https://node.renobuilding.ca:3001/message' , requestOptions)
			.then(response => {
				return Promise.all([response.json(),response])
			})
			.then(([responseData,response]) => {
				if(responseData.status){
					addNotification(responseData.message, 'success');
					var _index	=	log.findIndex(p=>p.person_email == email_to);
					log[_index].status	=	1;
					localStorage.setItem("person", JSON.stringify(log));
					if(--index == 1){
						setPerson(log);
					}
					setCurrentIndex(index);
				}
				else
				{
					addNotification(responseData.message, 'error');
					var _index	=	log.findIndex(p=>p.person_email == email_to);
					log[_index].status	=	-1;
					localStorage.setItem("person", JSON.stringify(log));
					if(--index == 1){
						setPerson(log);
					}
					setCurrentIndex(index);
					
				}
					
			})
			.catch(error => {
				console.error('Error:', error);
			})
			
	}
	
	useEffect(()=>{
		
		if(localStorage.getItem("person")){
			setPerson(JSON.parse(localStorage.getItem("person")));
			setEmail(JSON.parse(localStorage.getItem("email")));
			setSMS(JSON.parse(localStorage.getItem("sms")));
			setNumberOfSeleteced(Object.keys(JSON.parse(localStorage.getItem("person"))).length);
		}
		
	},[]);

	
	return(
		<>
			<Page className="DashboardPage" title={'Conversation'} breadcrumbs={[{ name: 'Conversation', active: true }]} >
				<Row>
					<Col md={12} sm={12} xs={12} className="mb-3">
						<Form>
							<FormGroup row >
								<Label md={1} >Group</Label>
								<Col md={5}>
									<ComboBox  onChange={(e)=>{setTemplateType(e.target.value);}} defaultValue={templateType}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="person_type" order="rb_type_no" />
								</Col>
								<Label md={1} >Tempates</Label>
								<Col md={5}>
									<ComboBox onChange={(e)=>{
										var __template_id = e.target.value;
										setTemplateId(__template_id);

										var dataAdapter =new DataAdapter("select * from rb_templates where template_id = " + __template_id);
											dataAdapter.getRecords().then((data)=>{
												setSms_body(data[0].task_desc);
												setEmail_text(data[0].task_desc);
												setTemplate_text(data[0].task_desc);
											});
										
									}}  table="rb_templates" valueField="template_id" displayField="template_name" filterField="person_type" filterValue={templateType }  order="template_name" />
								</Col>
							</FormGroup>
							<FormGroup row >
								<Label md={1} >Person</Label>
								<Col md={3}>
									<ComboBox size="5" multiple="true" name="person" onChange={(e)=>{
										if(templateId!=0){
											var _selectedOptions    =   e.target.selectedOptions;
											var _selectedId         =   "";
											for (let o of _selectedOptions) {
												_selectedId += o.value + ',';
											}
											var _person  	=   [];
											var _email  	=   [];
											var _sms  		=   [];
											var dataAdapter =new DataAdapter("select 0 AS `status`,p.* from rb_person p where p.person_id in (" + _selectedId + '-1)').getRecords().then((data)=>{
												data.map(data=>{
													_person.push({
														id				:	data.person_id,
														username		:	data.user_name,
														password		:	data.password,
														person_name     :   data.name + ' ' + data.lastname,
														person_tel      :   data.person_tel, 
														person_email    :   data.email,
														email_to        :   data.email,
														status			:	data.status
													});
													_email.push({
														id				:	data.person_id,
														email_text      :   template_text.replaceAll('[RECEIVER_NAME]', (data.name!=''?data.name:'') + ' ' + (data.lastname!=''?data.lastname:'')),    
														status			:	data.status
													});
													_sms.push({
														id				:	data.person_id,
														sms_body	    :   sms_body,
														status			:	data.status
													});
												});
											setPerson(_person);
											setEmail(_email);
											setSMS(_sms);
											setNumberOfSeleteced(_person.length);
											localStorage.setItem("person", JSON.stringify(_person));
											localStorage.setItem("email", JSON.stringify(_person));
											localStorage.setItem("sms", JSON.stringify(_person));
											});
										}else{
											addNotification("Please select a template!", "info");   
										}
										
									}}  table="rb_person" valueField="person_id" displayField="name,lastname" filterField="person_type" filterValue={templateType} orderby="name" />
								</Col>
								<Label md={1} >Selected ({currentIndex}/{numberOfSeleteced})</Label>
								<Col md={7}>
									<div style={{overflowY: 'scroll', height:'150px'}} >
									  
									  <Table dark size="sm">
										<thead>
										  <tr>
											<th>#</th>
											<th>Name</th>
											<th className="d-none" >Email</th>
											<th>Status</th>
										  </tr>
										</thead>
										<tbody>
										{person.map((p,i)=>{
											return(
												  <tr>
													<th scope="row">{i+1}</th>
													<td>{p.person_name}</td>
													<td  className="d-none" >{p.person_email}</td>
													<td>{p.status*1==1?"Done":(p.status*1==-1? "Failed":"In Queue")}</td>
												  </tr>
											)
										})}
										</tbody>
									  </Table>
									</div>
								</Col>
								<Label md={1} >Email Step (Sec.): </Label>
								<Col md={3}>
									<Input type={'number'} onChange={(e)=>{setEmail_step(e.target.value)}} value={email_step} />
								</Col>
								<Label md={1} >Email : </Label>
								<Col md={3}>
									<Input type={'text'} onChange={(e)=>{setEmail_from(e.target.value)}} value={email_from} />
								</Col>
								<Label md={1} >Pass: </Label>
								<Col md={3}>
									<Input type={'text'} onChange={(e)=>{setEmail_pass(e.target.value)}} value={email_pass} />
								</Col>
							</FormGroup>
						</Form>
						<FormGroup row >
							<Col>
								<Button color="secondary" onClick={(e)=>{}} >Load Template</Button>{' '}
								<Button color="secondary" onClick={(e)=>{
									 runQuery("UPDATE rb_templates SET task_desk = '" + email_text.replaceAll("'","") + "' WHERE template_id=" + templateId, "Template has been updated");

								}} >Save Template</Button>{' '}
								<Button color="secondary" onClick={(e)=>{
									var step    = email_step*1000;
									log	=	person;
									person.filter(p=>p.person_email!='' && p.status!=1).map((p,i)=>{
										var _timer  = (step*((i%3)+1)) *  index++
										setTimeout(()=>{
											addNotification("An email sent to " + p.person_name, "info" );
											onSendEmailHandler(p.person_email, email.filter(e=>e.person_id==p.person_id)[0].email_text)
										}, _timer);
										//addNotification("An email will be send to " + p.person_name + " after " + _timer/1000 + " s", "info");
									})

								}} >Send E-mail</Button>{' '}
								<Button color="secondary" onClick={(e)=>{}} >Send SMS</Button>{' '}
							</Col>
						</FormGroup>
						<FormGroup row >
							<Col>
								<Label>Subject</Label>
								<Input type="text"  onChange={(e)=>{setEmail_subject(e.target.value)}} value={email_subject} ></Input>
								<Label>eMail Body:</Label>
								<ReactQuill
								theme='snow'
								value={email_text}
								style={{minHeight: '400px'}}
								onChange={(e)=>{setEmail_text(e);}}
								/>			
							</Col>
							<Col>
								<Label>Message</Label>
								<Input 
									type="textarea" 
									style={{minHeight: '300px'}}									
									onChange={(e)=>{}} value={sms_body} ></Input>
							</Col>
						</FormGroup>
					</Col>
				</Row>
			</Page>
			<NotificationSystem ref={notificationSystem} style={NOTIFICATION_SYSTEM_STYLE}/>
		</>
	);
}

export default FormConversation;